import React from "react";
import { connect } from "react-redux";
import { SetDepositBankSearch, SetDepositBankActive } from '$Deposits/store/actions/DepositAction'
import { GetParamsData } from '$Deposits/lib/LibCommonData'

class BankSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {

        const { LivechatClick } = GetParamsData()
        const {
            BanksBankAccounts = [],
            DepositBankSearch,
            SetDepositBankSearch,
            DepositBankActive,
            SetDepositBankActive,
            MethodsActive,
            MethodCodeActive,
            BankSelect,
            CHANNEL,
            MethodsDetails,
            PHCbankList,
        } = this.props;
        const { isAutoAssign = false } = DepositBankActive || {}
        const { methods } = MethodsActive || {}
        let bankList = BanksBankAccounts.filter((v) => { return !v?.dummy })
        if (DepositBankSearch) {
            //搜索银行
            bankList = BanksBankAccounts.filter((v) => {
                //const name = (v.bankName || v.enBankName ||v.name).toLowerCase()
                return (v.bankName && v.bankName.toLowerCase().includes(DepositBankSearch.toLowerCase())) || 
                (v.enBankName && v.enBankName.toLowerCase().includes(DepositBankSearch.toLowerCase())) ||
                (v.name && v.name.toLowerCase().includes(DepositBankSearch.toLowerCase()))
            })
        }

        return (
            <>
                {
                    methods != 'CTC' && methods != 'PHC' &&
                    <BankSelect
                        BankList={bankList}
                        DepositBankActive={DepositBankActive}
                        onChange={(val) => { SetDepositBankActive(val) }}
                        onChangeSearch={(val) => { SetDepositBankSearch(val) }}
                        searchValue={DepositBankSearch}
                        LivechatClick={LivechatClick}
                        isAutoAssign={isAutoAssign}
                    />
                }

                {
                     methods == 'PHC' &&
                    <PHCbankList
                        BankList={bankList}
                        DepositBankActive={DepositBankActive}
                        onChange={(val) => { SetDepositBankActive(val) }}
                        MethodsDetails={MethodsDetails}
                    />
                }

                {
                    MethodCodeActive == 'CHANNEL' &&
                    <CHANNEL
                        BankList={bankList}
                        LivechatClick={LivechatClick}
                        DepositBankActive={DepositBankActive}
                        onChange={(val) => { SetDepositBankActive(val) }}
                    />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    BanksBankAccounts: state.BanksBankAccounts,
    DepositBankSearch: state.DepositBankSearch,
    DepositBankActive: state.DepositBankActive,
    MethodsActive: state.MethodsActive,
    MethodCodeActive: state.MethodCodeActive,
    MethodsDetails: state.MethodsDetails,
});
const mapDispatchToProps = {
    SetDepositBankSearch: (key = '') => SetDepositBankSearch(key),
    SetDepositBankActive: (data = {}) => SetDepositBankActive(data),

};
export default connect(mapStateToProps, mapDispatchToProps)(BankSelect);


